var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isComplete)?_c('div',{staticClass:"loading",class:{ 'is-open': _vm.isOpen, 'is-hide': _vm.isHide }},[_c('div',{staticClass:"bar",class:{ 'is-active': _vm.isBarActive }}),_c('img',{staticClass:"logo-image",attrs:{"src":require("../assets/logo.png")}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75100d4e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 